const defaultErrorMessages = {
  badRequest: 'There was a problem with the request.',
  forbidden: 'You are not allowed to do this.',
  unauthorized: 'You need to login to do this.',
  conflict: 'The request caused a conflict.',
  notFound: 'We could not find this.',
  internalServerError: 'Something went wrong. Don\'t worry, is on us. Try again later.',
};

export default function getErrorMessageFromStatus(statusCode, errorMessagesSet) {
  errorMessagesSet = errorMessagesSet || {};
  switch (statusCode) {
    case 400:
      return errorMessagesSet.badRequest || defaultErrorMessages.badRequest;
    case 401:
      return errorMessagesSet.unauthorized || defaultErrorMessages.unauthorized;
    case 403:
      return errorMessagesSet.forbidden || defaultErrorMessages.forbidden;
    case 404:
      return errorMessagesSet.notFound || defaultErrorMessages.notFound;
    case 409:
      return errorMessagesSet.conflict || defaultErrorMessages.conflict;
    case 500:
      return errorMessagesSet.internalServerError || defaultErrorMessages.internalServerError;
    default:
      return 'We had a problem processing your request. If it persists, please contact our support team.';
  }
}
